import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import Paginate from 'components/shared/Paginate';
import Text from 'components/shared/layouts/Text';

import BillCard from './BillCard';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.regular}px;
`;
const BillsList = ({ loading, items, pageCount, currentPage, onPageChange }) => {
  return (
    <StyledContainer>
      {items?.map((item) => (
        <BillCard key={item?.orderId} {...item} />
      ))}
      {!loading && !items?.length && <Text centered>No billing history found</Text>}
      <Paginate pageRangeDisplayed={3} pageCount={pageCount} currentPage={currentPage} onPageChange={onPageChange} />
    </StyledContainer>
  );
};

BillsList.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.array,
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default BillsList;
